import { createSlice } from '@reduxjs/toolkit';
import { getAllDriverTasks, getDetailDriverTask, updateDriverTask } from './actions';

const initialState = {
  data: {},
  selected: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const driversTask = createSlice({
  name: 'driversTask',
  initialState,
  reducers: {
    // reducers goes here
    resetSelected: (state) => {
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDriverTasks.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllDriverTasks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllDriverTasks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDetailDriverTask.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.selected = {};
      })
      .addCase(getDetailDriverTask.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDetailDriverTask.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selected = action.payload;
      })
      .addCase(updateDriverTask.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(updateDriverTask.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(updateDriverTask.fulfilled, (state) => {
        state.isLoading = false;
      });
  },
});

export const { resetSelected } = driversTask.actions;
export default driversTask.reducer;
